import PermissionButton from '../../permissions/PermissionButton';
import React from 'react';
import { Card, Descriptions, Button, Space, Tag } from 'antd';
import { useFetchEntrepotByCode } from '../../hooks/entrepotHooks';
import { useNavigate } from 'react-router-dom';

const SingleEntrepot = ({ code_ent, onChangeView }) => {
  const { entrepot, loading, error } = useFetchEntrepotByCode(code_ent);
  const navigate = useNavigate();

  if (loading) return <p>Chargement...</p>;
  if (error) return <p>Erreur: {error}</p>;
  if (!entrepot) return <p>Entrepôt non trouvé</p>;

  const isProtected = code_ent === '2';

  return (
    <Card
      title={`Entrepôt: ${entrepot.code_ent}`}
      extra={
        <Space>
          <PermissionButton permissionModule="warehouses" permissionAction="update" onClick={() => onChangeView('update')}>
            Modifier
          </PermissionButton>
          {!isProtected && (
            <PermissionButton permissionModule="warehouses" permissionAction="delete" danger onClick={() => onChangeView('delete')}>
              Supprimer
            </PermissionButton>
          )}
          {isProtected && (
            <Tag color="red">Protégé - Ne peut pas être supprimé</Tag>
          )}
          <Button onClick={() => onChangeView('list')}>
            Retour à la liste
          </Button>
        </Space>
      }
    >
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Code Entrepôt">
          {entrepot.code_ent}
        </Descriptions.Item>
        <Descriptions.Item label="Nom">
          {entrepot.name}
        </Descriptions.Item>
        <Descriptions.Item label="Date de création">
          {entrepot.createdAt ? new Date(entrepot.createdAt).toLocaleDateString() : '-'}
        </Descriptions.Item>
        <Descriptions.Item label="Dernière modification">
          {entrepot.updatedAt ? new Date(entrepot.updatedAt).toLocaleDateString() : '-'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default SingleEntrepot;

